// Mock data for Copium clone site

// ====== EASY-TO-EDIT CONSTANTS ======
// Change BASE_DOWNLOADS when you want to bump the displayed download counter
// (real downloads triggered on the site get added on top of this).
export const BASE_DOWNLOADS = 1293;
// ====================================

const v = (modVer, mcVer, sizeKB, date) => ({
  id: `${modVer}-mc${mcVer}`,
  label: `${modVer} \u2014 MC ${mcVer}`,
  version: modVer,
  mcVersion: `MC ${mcVer}`,
  size: `${sizeKB} KB`,
  date,
  downloadUrl: "#",
});

export const SITE_DATA = {
  brand: {
    name: "Copium",
    tagline: "Minecraft mods & utilities",
    iconUrl: "https://i.imgur.com/75pa4hY.png",
  },
  socials: {
    discord: "https://discord.gg/copium",
    tiktok: "https://www.tiktok.com/@copium",
  },
  mod: {
    name: "Copium",
    description: "A working DonutSMP client for 1.21.11",
    iconUrl: "https://i.imgur.com/75pa4hY.png",
  },
  versions: [
    v("1.2-SNAPSHOT", "1.21.11", 212, "2026-05-02"),
    v("1.2-SNAPSHOT", "1.21.10", 211, "2026-04-23"),
    v("1.1-SNAPSHOT", "1.21.9",  204, "2026-04-20"),
    v("1.1-SNAPSHOT", "1.21.8",  203, "2026-04-16"),
    v("1.1-SNAPSHOT", "1.21.7",  201, "2026-04-13"),
    v("1.0-SNAPSHOT", "1.21.6",  192, "2026-04-12"),
    v("1.0-SNAPSHOT", "1.21.5",  190, "2026-04-08"),
    v("1.0-SNAPSHOT", "1.21.4",  188, "2026-04-03"),
    v("1.0-SNAPSHOT", "1.21.3",  185, "2026-03-28"),
    v("1.0-SNAPSHOT", "1.21.2",  183, "2026-03-22"),
    v("1.0-SNAPSHOT", "1.21.1",  181, "2026-03-15"),
    v("1.0-SNAPSHOT", "1.21",    180, "2026-03-10"),
  ],
  changelog: [
    {
      version: "1.2-SNAPSHOT",
      date: "2026-05-08",
      changes: [
        "Placeholder",
        "Placeholder",
        "Placeholder",
      ],
    },
    {
      version: "1.1-SNAPSHOT",
      date: "2026-04-26",
      changes: [
        "Placeholder",
        "Placeholder",
      ],
    },
    {
      version: "1.0-SNAPSHOT",
      date: "2026-04-12",
      changes: [
        "Placeholder",
        "Placeholder",
      ],
    },
  ],
  scanner: {
    status: "clean",
    title: "No threats detected",
    verifiedBy: "VirusTotal",
    verifiedByUrl: "https://www.virustotal.com/gui/file/6ac0e3af6d7f16974542c1941fc209ccf6aa59b1d977d1b357ee9bc7bd895940",
    detail: {
      botName: "VirusTotal",
      time: "19:22",
      headerText: "Analysis Complete.",
      madeBy: "https://www.virustotal.com/",
      title: "Static Analysis Results for copium.jar",
      body: "The mod (copium.jar) was scanned across 70+ antivirus engines and no suspicious code was detected automatically. However, this doesn't mean that the mod is 100% safe.",
      enginesClean: 72,
      enginesTotal: 72,
    },
  },
};
